<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Profile</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="account.html">Forgot Password</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->

	<div class="page-lost-password u-s-p-t-80">
		<div class="container">
			<div class="page-lostpassword">
				<h2 class="account-h2 u-s-m-b-20">Forgot Password ?</h2>
				<h6 class="account-h6 u-s-m-b-30">
					Enter your email or username below and we will send you a link to reset your
					password.
				</h6>
				<form @submit.prevent="handleForgotPassword">
					<div class="w-50">
						<div class="u-s-m-b-13">
							<label for="user-name-email"
								>Username or Email
								<span class="astk">*</span>
							</label>
							<input
								type="text"
								id="user-name-email"
								class="text-field"
								placeholder="Username / Email"
								v-model="email"
								:disabled="loading"
								required
							/>
							<small id="passwordHelp" class="text-danger" v-if="error">
								{{ error.message }}
							</small>
						</div>

						<div class="u-s-m-b-13">
							<button class="button button-outline-secondary" :disabled="loading">
								{{ loading ? "Loading..." : "Get Reset Link" }}
							</button>
						</div>
					</div>
					<div class="page-anchor">
						<a @click="$router.back()">
							<i class="fas fa-long-arrow-alt-left u-s-m-r-9"></i>Back to Login</a
						>
					</div>
				</form>
			</div>
		</div>
	</div>
	<Footer />
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import Spinner from "../components/Loaders/Spinner.vue";
	import Popper from "vue3-popper";
	import {useToast} from "vue-toastification";
	export default {
		components: {Footer, Spinner, Popper},
		data() {
			return {
				email: "",
				error: "",
				loading: false,
			};
		},
		methods: {
			async handleForgotPassword() {
				this.loading = true;
				this.error = "";
				let url = process.env.VUE_APP_API_URL + "/api/forgot-password";
				let postData = {
					email: this.email,
				};
				try {
					// send post request
					let {data} = await axios.post(url, postData);
					console.log(data);
					this.loading = false;
					this.email = "";
					useToast().success("Password Reset Link Sent.", {timeout: 3000});
				} catch (error) {
					this.error = error.response.data;
					this.loading = false;
				}
			},
		},

		mounted() {},
	};
</script>

<style scoped></style>
